import { render, staticRenderFns } from "./referral-modal.vue?vue&type=template&id=89dca916&scoped=true&"
import script from "./referral-modal.vue?vue&type=script&lang=js&"
export * from "./referral-modal.vue?vue&type=script&lang=js&"
import style0 from "./referral-modal.vue?vue&type=style&index=0&id=89dca916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dca916",
  null
  
)

export default component.exports